import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-0 md:w-[50%] mx-auto"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex flex-row items-center gap-3 justify-end mt-4" }
const _hoisted_4 = {
  key: 1,
  class: "text-center py-12 bg-white rounded-lg border border-gray-200 shadow-sm px-4"
}

import { onMounted, ref } from 'vue'
import Voucher from '@/components/booking/Voucher.vue'
import { Booking } from '@/types'
import BookingService from '@/services/booking-service'
import { getSessionPrefix, isMakePaymentVisible, saveBookingNumber } from '@/utils/common'
import router from '@/router'
// @ts-ignore
import html2pdf from 'html2pdf.js'
import Modal from '@/widgets/Modal.vue'
import { saveUserSearch } from '@/services/search-service'
import CarService from '@/services/car-service'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingVoucher',
  props: ['number'],
  setup(__props) {

const props = __props
const data = ref<Booking | null>(null)
const isLoading = ref<boolean>(true)
const { readBooking } = BookingService()
const pdfContent = ref(null)
const openConfirmModal = ref<boolean>(false)
const showMakePaymentButton = ref<boolean>(false)
const { saveSelectedCar } = CarService()

onMounted(async () => {

   const response = await readBooking(props.number)
   isLoading.value = false
   
   if (response.success && response.data && response.data.data) {
      data.value = response.data.data
      if (data.value?.search?.pickUp?.date) {
         showMakePaymentButton.value = isMakePaymentVisible(data.value.search.pickUp.date)
      }
   } else {
      console.log(response.error)
   }
})

const downloadPDF = () => {
  const el = pdfContent.value as HTMLElement | null
  if (!el) return

  const filename =
    data.value?.number ? `User_Voucher_${data.value.number}.pdf` : 'User_Voucher.pdf'

  html2pdf()
    .set({
      filename,
      margin: [10, 10, 10, 10],
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: window.devicePixelRatio > 1 ? 2 : 1, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'] },
    })
    .from(el)
    .save()
}

const handleCancelBooking = () => {

   openConfirmModal.value = true
}

const handleMakePayment = () => {
   if (data.value) {
      saveUserSearch(data.value.search)
      saveBookingNumber(props.number)
      saveSelectedCar(data.value.car)
      router.push({name: 'BookingWizard', params: {step: 'contact-details'}})
   }
}

const handleConfirmClose = () => openConfirmModal.value = false


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (data.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  ref_key: "pdfContent",
                  ref: pdfContent
                }, [
                  _createVNode(Voucher, { data: data.value }, null, 8, ["data"])
                ], 512),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: handleCancelBooking,
                    type: "button",
                    class: "rounded-md bg-theme-button5-bg px-2.5 py-1.5 text-sm font-semibold text-theme-button5-txt shadow-sm"
                  }, " Cancel Booking "),
                  (showMakePaymentButton.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: handleMakePayment,
                        type: "button",
                        class: "rounded-md bg-theme-button1-bg px-2.5 py-1.5 text-sm font-semibold text-theme-button1-txt shadow-sm"
                      }, " Make Payment "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: downloadPDF,
                    type: "button",
                    class: "rounded-md bg-theme-button2-bg px-2.5 py-1.5 text-sm font-semibold text-theme-button2-txt shadow-sm"
                  }, " Download PDF ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                _createElementVNode("h2", { class: "text-xl font-bold text-gray-900" }, "Booking Not Found", -1),
                _createElementVNode("p", { class: "text-gray-500 mt-2 text-sm" }, "The booking reference you requested could not be located.", -1)
              ])))
        ]))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      show: openConfirmModal.value,
      onClosed: handleConfirmClose
    }, {
      content: _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "mt-8" }, " To cancel this booking contact our support representative at bookings@vehitraworld.com ", -1)
      ])),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})